import React from 'react';
import PropTypes from 'prop-types';

import { Select } from './versions';
import { Loader } from '../Loader';

/**
 * @param {object} props - Props.
 * @param {string} [props.icon] - Icon.
 * @param {string} props.label - Label.
 * @param {any[]} props.items - Items.
 * @param {Function} [props.itemToString] - Item to string.
 * @param {Function} [props.selectedItemToString] - The selected item's text displayed on the input.
 * @param {Function} [props.isReadyToRender] - Determines whether the select has
 *    all the info it needs to render.
 * @param {any} [props.initialSelectedItem] - Initial selected item.
 * @param {any} [props.activeItem] - Active item from state.
 * @param {Function} [props.onSelectedItemChange] - On change callback.
 * @returns {React.Element} Component.
 */
export const LoadableSelect = (props) => {
    const { isReadyToRender, ...otherProps } = props;

    const shouldShowLoader = (() => {
        if (isReadyToRender) {
            return !isReadyToRender();
        }

        return !props.items;
    })();

    if (shouldShowLoader) {
        return (
            <div className="select">
                <div className="select__loader-wrapper">
                    <Loader />
                </div>
            </div>
        );
    }

    return <Select {...otherProps} />;
};

LoadableSelect.propTypes = {
    isDisabled: PropTypes.bool,
    label: PropTypes.string,
    icon: PropTypes.string,
    items: PropTypes.arrayOf(PropTypes.any),
    itemToString: PropTypes.func,
    selectedItemToString: PropTypes.func,
    isReadyToRender: PropTypes.func,
    initialSelectedItem: PropTypes.any,
    activeItem: PropTypes.any,
    onSelectedItemChange: PropTypes.func
};
